import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import SuccessModal from "../../SuccessModal";
import { customerUpdate } from "../../../services/CustomerInfo/EditCustomer";
import { checkCustomerCode } from "../../../services/CustomerInfo/CustomerInfo";

export default function EditCustomerIdModal({
  setEditCustomerIdModalVisible,
  editCustomerIdModalVisible,
  customerIdName,
  editCustomerData,
  storeId,
  sendDataToEditCustomer,
}) {

  const [customerIdValue, setCustomerIdValue] = useState(customerIdName);
  const [checkCustomerIdValue, setCheckCustomerIdValue] = useState([]);
  const [customerIdError, setCustomerIdError] = useState("");

  const handleCustomerIdChange = (item) => {
    if (item === "") {
      setCustomerIdValue(item);
      setCustomerIdError("Please enter customer Id");
    } else {
      setCustomerIdValue(item);
      setCustomerIdError("");
    }
  };

  const handleCustomerIdExistOrNot = async () => {
    const data = {
      searchById: customerIdValue,
      storeId: storeId,
    };
    try {
      const response = await checkCustomerCode(storeId, data);
      if (!response.data.error) {
        const Res = response.data;
        if (Res.length > 0) {
          setCheckCustomerIdValue(Res);
        } else {
          handleEditData();
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleEditData = async () => {
    // Create a new edited field object

    // Update the specific field in editCustomerData
    let updatedData = { ...editCustomerData };

    updatedData.customerId = customerIdValue;
    // Add more conditions for other fields
    try {
      const response = await customerUpdate(updatedData);
      if (!response.data.error) {
        const Res = response.data;
        const message = Res.message;
        const status = Res.status;

        // Close the modal
        setEditCustomerIdModalVisible(false);
        sendDataToEditCustomer({
          success: true,
        });
        if (status === true) {
          setModalVisible(true);
          setModalStatus("success");
          setModalText(message);
        } else {
          setModalVisible(true);
          setModalStatus("not Success");
          setModalText(message);
        }
        // if (Res) {
        //   sendDataToEditCustomer({
        //     success: true,
        //   });
        // }
      }
      setCheckCustomerIdValue([])
    } catch (error) {
      console.error("Error:", error);
    }
    // Close the modal
    setEditCustomerIdModalVisible(false);
  };

  useEffect(() => {
    // When the fieldNameName or fieldNameValue changes, update the editValue
    if (customerIdName !== null) {
      setCustomerIdValue(customerIdName);
    }
  }, [customerIdName]);


  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleModalClose = () => {
    setCustomerIdValue("")
    setCheckCustomerIdValue([])
    setEditCustomerIdModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={editCustomerIdModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!editCustomerIdModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <i
                className="pi pi-user"
                style={{ fontSize: "50px", color: "#fff" }}
              ></i>
              <p className=" text-4xl text-primary-50 font-semibold">
                Customer Id
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div className="inline-flex flex-column gap-2 mx-4">
              <p className=" font-semibold">Customer Id</p>
              <InputText
                value={customerIdValue}
                onChange={(e) => handleCustomerIdChange(e.target.value)}
                id="firstName"
                label="firstName"
                placeholder="Enter First Name"
                className="w-full bg-white-alpha-20 p-2 border-round-xl text-xl "
              ></InputText>
              {customerIdError && (
                <p className="text-lg font-semibold" style={{ color: "red" }}>
                  {customerIdError}
                </p>
              )}
            </div>

            {checkCustomerIdValue.length > 0 ? (
              <>
                <div className="mb-2 mx-4">
                  <p className="text-lg font-semibold" style={{ color: "red" }}>
                    This Customer Id is already assigned to{" "}
                    {checkCustomerIdValue[0].brandCustomer.firstName +
                      " " +
                      checkCustomerIdValue[0].brandCustomer.lastName}
                  </p>
                </div>
                
              <Button
                  onClick={handleEditData}
                  className="mt-1 mb-3 mx-4 border-round-xl "
                      disabled={customerIdError ? true : false}
                >
                  <p className=" w-full text-2xl font-semibold flex justify-content-center">
                    UPDATE
                  </p>
                </Button>
                </>
            ) : (
              
                <Button
                  onClick={handleCustomerIdExistOrNot}
                  className="mt-1 mb-3 mx-4 border-round-xl "
                  disabled={customerIdError ? true : false}
                >
                  <p className=" w-full text-2xl font-semibold flex justify-content-center">
                    ADD
                  </p>
                </Button>
              
            )}
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
}
